module.exports = __webpack_public_path__ + "static/media/06-blog-index.4e438a2f.png";